export default {
    setTabs(state, data){
        state.categoryTabs      = data.list
    },
    setAppraisers(state, data){
        let {myAppraiser, appraisers} = data;
        state.appraisers        = {myAppraiser, appraisers}
    },
    setAppraisersList(state, data){
        let {appraisers, page, query} = data;
        let tabid = query.tabid || '0';
        if (state.appraiserList) {
            if(state.appraiserList[tabid] && page > 1) {
                state.appraiserList[tabid] = state.appraiserList[tabid].concat(appraisers)
            } else {
                state.appraiserList[tabid] = appraisers
            }
        } else {
            state.appraiserList = {[tabid]:appraisers};
        }

       // state.appraisers        = {myAppraiser, appraisers}
    },
    setOrders(state, data){
        if(data.list){
            state.orders        = data.list || []
        }
    },
    setFinishOrders(state, data){
        if(data.list && data.list.length){
            if(data.page > 1){
                state.finishOrders  = state.finishOrders.concat(data.list);

            } else {
                state.finishOrders  = data.list
            }
        } else {
            state.finishOrders      = []
        }
    },
    setAuthenticated(state, data){
        if(data.list){
            state.authenticatedList = data.list || []
        }
    },
    setOrderDetail(state, data){
        if(data && data.detail){
            state.orderDetail   = data.detail
        }
    },
    delOrderDetail(state){
        state.orderDetail       = null
    },
    delStateByKey(state, data){
        if(data.key && state[data.key]){
            state[data.key]     = null
        }

    },
    setAppraiserInfo(state, data){
        state.appraiserInfo     = Object.assign(state.appraiserInfo, data);
    },

    setDetailAppraiser(state, data){
        state.detailAppraiser   = data.appraiser;
    },

    setJdConfig(state, data){
        state.jdConfig          = Object.assign(state.jdConfig, data);
    },
    setTake(state, data){
        state.takeInfo          = Object.assign(state.takeInfo, data);
    },
    setKeyword(state, data){
        state.searchKey         = data.keyword || '';
    },
    setMoneyLog(state, data){
        if(data.page > 1){
            state.moneyLog          = state.moneyLog.concat(data.list || []);
        } else {
            state.moneyLog          = data.list || [];
        }

    }

}